
import resepcionistPanel from '@/components/Resepcionist/Panel'

export default {
    path: '/recepcion',
    name: 'recepcion',
    component: resepcionistPanel,
    children: []
}



// WEBPACK FOOTER //
// ./src/router/recepcionist.js